import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

interface LanguageSwitcherProps {
    className?: string;
}

export default function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'fr' ? 'en' : 'fr';
        i18n.changeLanguage(newLang);
    };

    const isFrench = i18n.language === 'fr';

    return (
        <button
            onClick={toggleLanguage}
            className={`flex items-center gap-2 p-2 rounded-xl hover:bg-dark-hover transition-colors ${className}`}
            title={isFrench ? 'Switch to English' : 'Passer en Français'}
        >
            <div className="w-6 h-6 rounded-full overflow-hidden border border-border shadow-sm">
                {isFrench ? (
                    <svg viewBox="0 0 3 2" className="w-full h-full object-cover">
                        <rect width="1" height="2" x="0" fill="#0055A4" />
                        <rect width="1" height="2" x="1" fill="#FFFFFF" />
                        <rect width="1" height="2" x="2" fill="#EF4135" />
                    </svg>
                ) : (
                    <svg viewBox="0 0 60 30" className="w-full h-full object-cover">
                        <clipPath id="uk-flag-s">
                            <path d="M0,0 v30 h60 v-30 z" />
                        </clipPath>
                        <clipPath id="uk-flag-t">
                            <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
                        </clipPath>
                        <g clipPath="url(#uk-flag-s)">
                            <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                            <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#uk-flag-t)" stroke="#C8102E" strokeWidth="4" />
                            <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                            <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
                        </g>
                    </svg>
                )}
            </div>
            <span className="text-sm font-bold uppercase text-text-muted hover:text-text-main">
                {i18n.language}
            </span>
        </button>
    );
}
